var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _path12, _path13, _path14, _path15, _path16;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgLogoStar(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 242,
    height: 354,
    viewBox: "0 0 242 354",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M190.394 0V176.576",
    stroke: "white",
    strokeOpacity: 0.1,
    strokeWidth: 6.52778,
    strokeMiterlimit: 10
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M116.94 13.8066L190.394 176.574",
    stroke: "white",
    strokeOpacity: 0.1,
    strokeWidth: 6.52778,
    strokeMiterlimit: 10
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M54.9842 53.0898L190.394 176.577",
    stroke: "white",
    strokeOpacity: 0.1,
    strokeWidth: 6.52778,
    strokeMiterlimit: 10
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M14.2024 111.678L190.394 176.579",
    stroke: "white",
    strokeOpacity: 0.1,
    strokeWidth: 6.52778,
    strokeMiterlimit: 10
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M1 180.416L190.394 176.572",
    stroke: "white",
    strokeOpacity: 0.1,
    strokeWidth: 6.52778,
    strokeMiterlimit: 10
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M17.405 248.582L190.394 176.572",
    stroke: "white",
    strokeOpacity: 0.1,
    strokeWidth: 6.52778,
    strokeMiterlimit: 10
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M60.9056 305.45L190.394 176.572",
    stroke: "white",
    strokeOpacity: 0.1,
    strokeWidth: 6.52778,
    strokeMiterlimit: 10
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M124.636 342.174L190.394 176.572",
    stroke: "white",
    strokeOpacity: 0.1,
    strokeWidth: 6.52778,
    strokeMiterlimit: 10
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M198.666 352.998L190.394 176.572",
    stroke: "white",
    strokeOpacity: 0.1,
    strokeWidth: 6.52778,
    strokeMiterlimit: 10
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M271.405 336.204L190.394 176.572",
    stroke: "white",
    strokeOpacity: 0.1,
    strokeWidth: 6.52778,
    strokeMiterlimit: 10
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M331.472 294.455L190.394 176.572",
    stroke: "white",
    strokeOpacity: 0.1,
    strokeWidth: 6.52778,
    strokeMiterlimit: 10
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M369.466 234.236L190.394 176.572",
    stroke: "white",
    strokeOpacity: 0.1,
    strokeWidth: 6.52778,
    strokeMiterlimit: 10
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M379.442 165.025L190.394 176.58",
    stroke: "white",
    strokeOpacity: 0.1,
    strokeWidth: 6.52778,
    strokeMiterlimit: 10
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    d: "M359.858 97.6074L190.394 176.575",
    stroke: "white",
    strokeOpacity: 0.1,
    strokeWidth: 6.52778,
    strokeMiterlimit: 10
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    d: "M313.753 42.5449L190.394 176.577",
    stroke: "white",
    strokeOpacity: 0.1,
    strokeWidth: 6.52778,
    strokeMiterlimit: 10
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    d: "M252.074 8.46094L190.67 176.662",
    stroke: "white",
    strokeOpacity: 0.1,
    strokeWidth: 6.52778,
    strokeMiterlimit: 10
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogoStar);
export default __webpack_public_path__ + "static/media/logo-star.c30c75151a50a05d5b13cdcbb342fec7.svg";
export { ForwardRef as ReactComponent };